import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'fgb-how-it-works',
  templateUrl: './how-it-works.component.html',
  styleUrls: ['./how-it-works.component.scss'],
})
export class HowItWorksComponent {
  @ViewChild('howItWorksModal') modalTemplate!: TemplateRef<any>;

  constructor(private modalService: NgbModal) {}

  openModal(): void {
    this.modalService.open(this.modalTemplate, {
      centered: true,
      size: 'xl',
      windowClass: 'how-it-works-modal',
    });
  }
}
